<template>
  <vs-dropdown vs-trigger-click class="cursor-pointer add-dropdown">

    <vs-button color="primary" icon-pack="feather" icon="icon-plus"><span v-if="title">{{title}}</span></vs-button>
    <vs-dropdown-menu class="add-dropdown__menu">
      <vs-dropdown-item @click="$emit('addGoalClick')">
        <span class="flex items-center">
          <feather-icon icon="PlusSquareIcon" svgClasses="h-4 w-4" class="mr-2" />
          <span>New Goal</span>
        </span>
      </vs-dropdown-item>

      <vx-tooltip :text="selectGoalEnabled ? 'Choose which goals you want to add for this month' : 'All your goals are assigned to some month'" position="left" >
      <vs-dropdown-item :disabled="!selectGoalEnabled" @click="$emit('assignGoalClick')">

          <span class="flex items-center">
            <feather-icon icon="CornerLeftDownIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>Assign&nbsp;Goal&nbsp;({{selectGoalEnabled}})</span>
          </span>

      </vs-dropdown-item>
      </vx-tooltip>

    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>

export default {
  props: {
    selectGoalEnabled: {
      type: Number,
    },
    title: {
      type: String,
      required: false,
      default: 'Add'
    }
  },
}

</script>
